import React, { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Modal } from "@lib/modal";
import { Button } from "@components/buttons";
import { useFixBody } from "@state/hooks/shared";

export default observer(function MyBetsReuseConfirmation(props: {
	betSlipNumber?: string;
	onClose: () => void;
	onAccept: () => void;
	isOpen?: boolean;
}) {
	const { t } = useTranslation();
	useFixBody(true, props.isOpen);

	const [isYesButtonDisabled, setIsYesButtonDisabled] =
		useState<boolean>(false);

	function onClick() {
		setIsYesButtonDisabled(true);

		props.onAccept();
	}

	if (!props.isOpen) {
		return null;
	}

	return (
		<Modal>
			<div className="popup" data-at="at-MyBetsReuseConfirmation">
				<div className="popup__card popup__card--med">
					<div className="popup__header">
						{t("mybets:REUSE.TITLE")}
					</div>
					<div className="popup__body">
						<div>
							{t("mybets:REUSE.MESSAGE", {
								bsn: props.betSlipNumber,
							})}
						</div>
					</div>
					<div className="popup__footer">
						<button
							className="popup__btn btn btn--med btn--primary--inverted"
							onClick={props.onClose}
							type="button"
						>
							{t("COMMON.CANCEL")}
						</button>
						<Button
							className="popup__btn btn btn--med btn--accent"
							onClick={onClick}
							type="submit"
							btnText={t("COMMON.YES")}
							disabled={isYesButtonDisabled}
						></Button>
					</div>
				</div>
			</div>
		</Modal>
	);
});
